import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMagnifierMinus12 from './IconMagnifierMinus12';
import IconMagnifierMinus16 from './IconMagnifierMinus16';
import IconMagnifierMinus20 from './IconMagnifierMinus20';
import IconMagnifierMinus24 from './IconMagnifierMinus24';
import IconMagnifierMinus32 from './IconMagnifierMinus32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMagnifierMinus = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMagnifierMinus12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMagnifierMinus16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMagnifierMinus20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMagnifierMinus24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMagnifierMinus32 {...props} />}
        </span>
    );
};
IconMagnifierMinus.displayName = 'FondueIconMagnifierMinus';

export default memo(IconMagnifierMinus);
